import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  GENDER_ADDITIONAL_LABELS,
  GENDER_ADDITIONAL_OPTIONS,
  GENDER_LABELS,
  GENDER_OPTIONS
} from 'utils/influencers';

import type {
  InfluencerProfile,
  InfluencerProfileForm,
  LocationGeo,
  MixedSelectDropdownItem
} from 'types';

export const hasFashionIdentity = (
  profile: InfluencerProfile | InfluencerProfileForm
): boolean => (
  !isEmpty(profile.fashionStyles)
  || !isEmpty(profile.fashionCategories)
  || !isEmpty(profile.fashionSizes)
);

export const hasSelfIdentity = (
  profile: InfluencerProfile | InfluencerProfileForm,
  mode: 'view' | 'edit'
): boolean => {
  const genderStatus = mode === 'view'
    ? profile.influencerGender
    : profile.influencerGenderAdditional;

  return !isEmpty(genderStatus)
    || (!isNil(profile.ethnicGroup) && profile.ethnicGroup !== 'none');
};

export const mapGeoLocationToMixedDropdown = (
  location: LocationGeo
): MixedSelectDropdownItem => {
  const fullName = `${location.city}, ${location.state}, ${location.country}`;

  return {
    identifier: fullName,
    isDisabled: false,
    isFocused: false,
    isSelected: true,
    label: fullName,
    labelWhenSelected: location.city,
    value: fullName,
    data: location
  };
};

export const getGenderItems = (
  profile: InfluencerProfileForm
): Array<MixedSelectDropdownItem> => (
  [...GENDER_OPTIONS].map(value => ({
    identifier: value,
    isDisabled: false,
    isSelected: profile.influencerGender === value,
    label: GENDER_LABELS[value],
    value
  }))
);

export const getGenderAdditionalItems = (
  profile: InfluencerProfileForm
): Array<MixedSelectDropdownItem> => (
  [...GENDER_ADDITIONAL_OPTIONS].map(value => ({
    identifier: value,
    isDisabled: false,
    isSelected: profile.influencerGenderAdditional === value,
    label: GENDER_ADDITIONAL_LABELS[camelCase(value)],
    value
  }))
);
